<script lang="ts">
  import Button from '$lib/components/control/Button.svelte';
  import ResponsiveMedia from '../control/ResponsiveMedia.svelte';
  import { DESKTOP_TEXT_ALIGNMENT } from '$lib/constants/constants.js';
  import { richTextFormatter } from '$lib/helpers/richTextHelper';
  import type { HeroBannerProps } from '$lib/types/contentTypes';

  export let heroBanner: HeroBannerProps;
  export let heroHeight = 'min-h-[min(53.75rem,90vh)]';
  export let heroMargin = 'my-36';

  let heroAlignment = heroBanner?.desktopTextAlignment || DESKTOP_TEXT_ALIGNMENT.CENTER;

  let showScrim = typeof heroBanner?.scrimOverlay === 'string';

  let textColour =
    heroBanner?.textColour === 'White'
      ? 'text-white'
      : heroBanner?.textColour === 'Dark Grey'
        ? 'text-gray-800'
        : '';
</script>

<section
  class="relative flex w-full {heroHeight} flex-col bg-gray-950 [&_img]:object-top {heroAlignment ===
  DESKTOP_TEXT_ALIGNMENT.BOTTOM
    ? 'items-center justify-end text-center'
    : ''} {heroAlignment === DESKTOP_TEXT_ALIGNMENT.CENTER
    ? 'items-center justify-center text-center'
    : ''} {heroAlignment === DESKTOP_TEXT_ALIGNMENT.LEFT
    ? 'items-start justify-center text-left'
    : ''}"
>
  {#if heroBanner.backgroundMedia}
    <ResponsiveMedia
      desktopMedia={heroBanner.backgroundMedia}
      mobileMedia={heroBanner?.backgroundMediaMobile}
      desktopSizeQuery="w=2400&q=85&fm=webp"
      mobileSizeQuery="w=780&q=85&fm=webp"
      preload={true}
      videoPoster={heroBanner?.videoPoster}
      scrimOpacity={heroBanner?.scrimOverlay}
      {showScrim}
    />
  {/if}
  <div class="relative {heroMargin} flex w-full mx-auto max-w-1280 flex-col px-4 lg:px-8">
    <div
      class="flex flex-col {heroAlignment === DESKTOP_TEXT_ALIGNMENT.BOTTOM
        ? 'items-center justify-end'
        : ''} {heroAlignment === DESKTOP_TEXT_ALIGNMENT.CENTER
        ? 'items-center justify-center'
        : ''} {heroAlignment === DESKTOP_TEXT_ALIGNMENT.LEFT ? 'items-start justify-center' : ''}"
    >
      {#if heroBanner?.title}
        <h1
          class="mb-4 mt-12 text-display-md font-bold leading-[2.5rem] [text-wrap:balance] lg:text-display-2xl lg:leading-none xl:mt-16 {textColour}"
        >
          {heroBanner?.title}
        </h1>
      {/if}
      <div class="banner-description max-w-[48rem] tracking-[-0.02em] [&_>*]:text-[1.2rem]">
        {@html richTextFormatter(heroBanner?.heroBannerDescription, textColour)}
      </div>
      <div class="flex max-w-[48rem] flex-col md:flex-row">
        {#if heroBanner?.heroBannerCallToAction}
          <Button
            {...heroBanner?.heroBannerCallToAction}
            customClass="mt-5 !p-[0.625em_2em] md:mt-8 plausible-event-name=hero_CTA_{heroBanner?.title
              ?.split(' ')
              .join('_')}"
          />
        {/if}
        {#if heroBanner?.heroBannersecondCta}
          <Button
            {...heroBanner?.heroBannersecondCta}
            customClass="mt-5 !p-[0.625em_2em] md:ml-3 md:mt-8 plausible-event-name=hero_2CTA_{heroBanner?.title
              ?.split(' ')
              .join('_')}"
          />
        {/if}
      </div>
    </div>
  </div>
  <a href={heroBanner?.bannerLink} class="absolute top-0 right-0 bottom-0 left-0 z-2 opacity-0.01">
  </a>
</section>
